import { defineComponent as _defineComponent } from 'vue'
import { shallowRef, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseElScrollbar',
  emits: ['edit-res', 'cursor-change'],
  setup(__props, { expose, emit: emits }) {

const scrollRef = shallowRef<HTMLDivElement>()
const isEdit = ref(false)


function handleKeyup () {
  emits('cursor-change')
}

function setScrollTop(v: number) {
  scrollRef.value?.scrollTo({
    top: v
  })
}

function handleInput () {
  isEdit.value = true
  emits('edit-res', isEdit.value)
}
expose({
  setScrollTop
})


return { __sfc: true,scrollRef, isEdit, emits, handleKeyup, setScrollTop, handleInput }
}

})